<template>
  <div class="relative rounded-md border">
    <div
      class="absolute inset-y-0 right-0 flex w-10 items-center justify-center rounded-r-md border-l border-background-fg/8 bg-background text-background-fg"
    >
      <IconX v-if="modelValue" @click="handleClearInput" />
      <IconSearch v-else />
    </div>
    <BaseTextInput
      :model-value="modelValue"
      placeholder="search"
      class="border-none pr-10"
      @update:model-value="handleInnerInputUpdate"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: string
}>()

const emit = defineEmits<{
  (eventName: "update:modelValue", value: string): void
}>()

const handleInnerInputUpdate = (value: string) => {
  emit("update:modelValue", value)
}

const handleClearInput = () => {
  emit("update:modelValue", "")
}
</script>
